import { State } from '../state';

export const TrendChannelSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    selectedChannels: (state: State) => state.SelectedTrendChannels.selectedChannels,
    channelsForGraph: (state: State): number[] => state.SelectedTrendChannels.channelsForGraph,
};
